import React from "react";
import "./Footer.css";

const SocialLink = ({ href, iconClass }) => (
  <li>
    <a href={href} target="_blank" rel="noopener noreferrer">
      <i className={iconClass}></i>
    </a>
  </li>
);

const FooterLink = ({ href, text }) => (
  <li>
    <a href={href} target="_blank" rel="noopener noreferrer">
      {text}
    </a>
  </li>
);

const socialLinks = [
  { href: "https://twitter.com", iconClass: "bi bi-twitter" },
  { href: "https://discord.com", iconClass: "bi bi-discord" },
  { href: "https://www.instagram.com/definfts/", iconClass: "bi bi-instagram" },
  { href: "https://facebook.com", iconClass: "bi bi-facebook" },
  { href: "https://youtube.com", iconClass: "bi bi-youtube" },
];

const footerLinks = [
  { href: "/", text: "Vision & Mission" },
  { href: "/", text: "Resources" },
  { href: "/", text: "News" },
  { href: "/", text: "Sign In" },
  { href: "/", text: "Sign Up" },
];

export default function Footer() {
  return (
    <section className="Footer">
      <div className="container">
        <div className="row">
          <div className="join-us">
            <div className="banner">
              <h5>
                Your contribution will go a long way to support kids’ education.
                We thank you from the <span>bottom of our hearts!</span>
              </h5>
              <div className="cta">
                <a href="/fghgfg" className="cta button volunteer-button">
                  Volunteer
                </a>
                <a href="/ghfghfg" className="cta button donate-button">
                  Donate
                </a>
              </div>
            </div>
          </div>

          <ul className="social-links">
            {socialLinks.map((link, index) => (
              <SocialLink
                key={index}
                href={link.href}
                iconClass={link.iconClass}
              />
            ))}
          </ul>

          <ul className="footer-links">
            {footerLinks.map((link, index) => (
              <FooterLink key={index} href={link.href} text={link.text} />
            ))}
          </ul>
          <p className="copy">© 2024 Singapore Kindness Movement</p>
        </div>
      </div>
    </section>
  );
}
